export const mapPhoneNumberToDisplay = (number) => {
  if (!number) return '';
  const areaCode = number.slice(2, 5);
  const middle = number.slice(5, 8);
  const last = number.slice(8);
  return [areaCode, middle, last].join('-');
};

export const mapPhoneNumberFromDisplay = (display) => {
  if (!display) return '';
  const parts = display.split('-');
  return '+1'.concat(parts.join(''));
};
